export default class Documento {
  constructor() {
    this.id = 0;
    this.descricao = "";
    this.numero = "";
    this.tipo = "";
    this.data = new Date();
  }
}
